// 列表数据 格式化工具
import dayjs from 'dayjs'

export const format = (list: any, type: any, str: any) => {
  if (!list || list.length === 0 || !type) return []
  let res = [...list]
  if (type === 'date') res = formatTime(res, str)
  if (type === 'state') res = formaState(res, str)
  if (type === 'trim') res = formaTrim(res, str)
  return res
}

const formatTime = (list: any, str: any) => {
  if (!list || list.length === 0) return []
  return list.map((v: any) => {
    if (v[str]) {
      v[str] = (v[str] === '-1' || v[str] === -1) ? '' : dayjs(v[str]).format('YYYY-MM-DD HH:mm')
    }
    return v
  })
}

const stateDict: any = {
  stuSchoolRollStatus: {
    0: '无效',
    1: '有效'
  },
  state: {
    0: '无效',
    1: '有效'
  }
}

const formaState = (list: any, str: any) => {
  if (!list || list.length === 0) return []
  return list.map((v: any) => {
    if (v[str]) {
      v[str] = stateDict[str][v[str]]
    }
    return v
  })
}

const formaTrim = (list: any, str: any) => {
  if (!list || list.length === 0) return []
  return list.map((v: any) => {
    if (v[str]) {
      v[str] = (v[str] === '-1' || v[str] === -1) ? '' : v[str]
    }
    return v
  })
}

export const formatValue = (val: any, type: any) => {
  if (!val || val === -1 || val === '-1') return ''
  if (type === 'date') return dayjs(val).format('YYYY-MM-DD HH:mm')
  if (type === 'state') return stateDict.state[val]
  return val
}
